module.exports = __webpack_public_path__ + "img/bespoke123_30.c2809f8a.jpg";